import { render } from "./TopRankingTemplate.vue?vue&type=template&id=78370e79"
import script from "./TopRankingTemplate.vue?vue&type=script&lang=js"
export * from "./TopRankingTemplate.vue?vue&type=script&lang=js"
script.render = render

export default script